import { Injectable } from '@angular/core';
import { HttpRequestPayload, IHttpErrorPayload, IHttpSuccessPayload } from '@core/models';
import { HttpProviderService } from '@core/service';
import { catchError, map, Observable, throwError } from 'rxjs';

@Injectable()
export class EnrollmentService {

  constructor(private _httpProvider : HttpProviderService) { }

  public getEnrollment():Observable<any>{
    const requestPayload : HttpRequestPayload = {
      method :'GET',
      resource: `/lov`,
      queryParams: [
        {
          key: 'lovId',
          value: 'TOGGLE_OPTION',
        },
        {
          key: 'lookup',
          value: '1',
        },
      ],
    }
    return this._httpProvider.invokeApi(requestPayload).pipe(
      map((res : IHttpSuccessPayload<any>)  => res.body.Data),
      catchError((err: IHttpErrorPayload) => {
        return throwError(err);
      })
    )
  }
}
